export default {
  en: {
    message: {
      PublicParameter: 'Public Parameter',
      PublicRequestParameter: 'Public Request Parameter',
      Description: 'Description',
      Field: 'Field',
      Memo: 'Memo',
      Value: 'Value',
      User: 'User',
      wmsAccount: 'Main Acount To Visit Vwms',
      forGenSign: 'To Generate Digital Signature',
      ProvidedByVwms: 'Provided By Vwms',
      ProvidedByErp: 'Provided By Erp',
      WarehouseCode: 'Warehouse Code',
      ResponseUrl: 'Response Url',
      UrlForErp: 'Url For Erp To Receive Response From Vwms',
      Instruction: 'Instruction',
      RequestMethod: 'Request Method',
      RequestMethod2: 'Request Url: The Red Part Is Parameter (Provided By Vwms); The Green Part Is Digital Signature ( Refer To Digital Signature Generation Method)',
      RequestMethod3: 'This interface strictly distinguishes the case of fields, please ensure that the interface fields are consistent with the case of the document',
      SignMethod: 'Digital Signature Generation Method',
      SignMethod2: 'Request Url: The Red Part Is Parameter (Provided By Vwms); The Green Part Is Digital Signature )',
      SignMethod3: 'Generation Parameter( From Url)',
      SignMethod4: 'Generation Parameter( Sort By First Letter)',
      SignMethod5: 'Send Parameter By Parameter Name + Value (Without "="); Request Parameter Is Send By Body; The Secetkey Is Provided By Vwms',
      SignMethod6: 'MD5 encrypts the above string',
      RequestParameter: 'Request Parameter',
      ResponseParameter: 'Response Parameter',
      ApiTool: 'Api Tool',
      ApiDebugTool: 'Api Test Tool',
      ApiName: 'Api Name',
      ApiAddress: 'Api Address',
      SignString: 'Signature String',
      Md5String: 'Md5 Signature',
      RequestAddress: 'Request Address',
      selectLan: 'Languages'
    }
  },
  cn: {
    message: {
      PublicParameter: '公共参数',
      PublicRequestParameter: '公共请求参数',
      Description: '字段含义',
      Field: '字段',
      Memo: '备注',
      Value: '环境配置值',
      User: '用户',
      wmsAccount: '访问VWMS的总账号',
      forGenSign: '用于生成签名',
      ProvidedByVwms: '由Vwms提供',
      ProvidedByErp: '由Erp提供',
      WarehouseCode: '仓库编码',
      ResponseUrl: '确认接口地址',
      UrlForErp: 'ERP接收确认消息的应用地址',
      Instruction: '接口使用方式',
      RequestMethod: '请求方式',
      RequestMethod2: '请求url，红色部分为变量，由WMS提供。绿色部分为签名，签名方式请参照签名生成方式',
      RequestMethod3: '本接口严格区分字段大小写，请务必保证接口字段与文档大小写保持一致',
      SignMethod: '签名生成方式',
      SignMethod2: '请求url，红色部分为变量，由WMS提供。绿色部分为签名',
      SignMethod3: '签名生成参数为url中所带参数',
      SignMethod4: '参数按首字母升序排列',
      SignMethod5: '去掉等号连接参数，body为请求参数，secretkey由WMS提供',
      SignMethod6: 'MD5加密上述字符串',
      RequestParameter: '请求参数',
      ResponseParameter: '响应参数',
      ApiTool: 'API工具',
      ApiDebugTool: 'API测试工具',
      ApiName: '接口名称',
      ApiAddress: '接口地址',
      SignString: '签名字符串',
      Md5String: 'Md5 签名',
      RequestAddress: '请求地址',
      selectLan: '选择语言'
    }
  }
}



// WEBPACK FOOTER //
// ./src/languages/languages.js